"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        var filterOptionsStore;
        (function (filterOptionsStore) {
            const OPTIONS_CACHE_TTL_MS = 2 * 60 * 1000;
            const _cache = new Map();
            const _selections = new Map();
            function getCached(key, search) {
                const cached = _cache.get(key);
                if (!cached || Date.now() - cached.fetchedAt >= OPTIONS_CACHE_TTL_MS)
                    return null;
                if (search === '')
                    return cached.options;
                if (!cached.complete)
                    return null;
                const term = search.toLowerCase();
                return cached.options.filter(o => (o.display || o.value).toLowerCase().includes(term));
            }
            filterOptionsStore.getCached = getCached;
            function setCached(key, options) {
                const valueCount = options.filter(o => o.value !== '').length;
                _cache.set(key, { options: options, complete: valueCount < distill.dashboards.FILTER_OPTIONS_LIMIT, fetchedAt: Date.now() });
            }
            filterOptionsStore.setCached = setCached;
            function clearCaches(prefix) {
                _cache.forEach((_, key) => {
                    if (key.startsWith(prefix))
                        _cache.delete(key);
                });
            }
            filterOptionsStore.clearCaches = clearCaches;
            function getSelections(key) {
                let selections = _selections.get(key);
                if (!selections) {
                    selections = new Map();
                    _selections.set(key, selections);
                }
                return selections;
            }
            filterOptionsStore.getSelections = getSelections;
            function hasSelections(key) {
                return _selections.has(key);
            }
            filterOptionsStore.hasSelections = hasSelections;
            function seedSelections(key, values) {
                _selections.set(key, new Map(values.map(v => [v, { display: v, count: 0 }])));
            }
            filterOptionsStore.seedSelections = seedSelections;
            function deleteSelections(key) {
                _selections.delete(key);
                _validatedAt.delete(key);
            }
            filterOptionsStore.deleteSelections = deleteSelections;
            function deleteSelectionsByPrefix(prefix) {
                _selections.forEach((_, key) => {
                    if (key.startsWith(prefix))
                        _selections.delete(key);
                });
                _validatedAt.forEach((_, key) => {
                    if (key.startsWith(prefix))
                        _validatedAt.delete(key);
                });
            }
            filterOptionsStore.deleteSelectionsByPrefix = deleteSelectionsByPrefix;
            let _generation = 0;
            const _validatedAt = new Map();
            function bumpGeneration() {
                _generation++;
            }
            filterOptionsStore.bumpGeneration = bumpGeneration;
            function selectionsStale(key) {
                var _a;
                return getSelections(key).size > 0 && ((_a = _validatedAt.get(key)) !== null && _a !== void 0 ? _a : -1) !== _generation;
            }
            filterOptionsStore.selectionsStale = selectionsStale;
            function markSelectionsValidated(key) {
                _validatedAt.set(key, _generation);
            }
            filterOptionsStore.markSelectionsValidated = markSelectionsValidated;
        })(filterOptionsStore = dashboards.filterOptionsStore || (dashboards.filterOptionsStore = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
